import OtpLogs from './OtpLogs';

const OtpLogsConfig = {
  settings: {},
  routes: [
    {
      path: '/apps/otp-logs',
      component: OtpLogs
    }
  ]
};

export default OtpLogsConfig; 